export enum Category {
  MAINTENANCE_RECORD = 'MAINTENANCE_RECORD',
  INSPECTION_REPORT = 'INSPECTION_REPORT',
  REPAIR_INVOICE_OR_SERVICE_REPORT = 'REPAIR_INVOICE_OR_SERVICE_REPORT',
  INSTALLATION_DOCUMENT = 'INSTALLATION_DOCUMENT',
  PRODUCT_DOCUMENTATION = 'PRODUCT_DOCUMENTATION',
  OTHER = 'OTHER',
}

export const CATEGORY_LABELS: Record<Category, string> = {
  [Category.MAINTENANCE_RECORD]: 'Maintenance record',
  [Category.INSPECTION_REPORT]: 'Inspection report',
  [Category.REPAIR_INVOICE_OR_SERVICE_REPORT]: 'Repair invoice or service report',
  [Category.INSTALLATION_DOCUMENT]: 'Installation document',
  [Category.PRODUCT_DOCUMENTATION]: 'Product documentation',
  [Category.OTHER]: 'Other',
};
